<div class="barWrapper">
  <div class="progress">
    <div class="progress-bar custom-tooltip" [ngStyle]="{width: progressWidth}">
        <span class="tooltiptext">{{progressWidth}}</span>
    </div>
  </div>
</div>




// WEBPACK FOOTER //
// ./src/app/storyboard-publish/storyboard-progress-bar/storyboard-progress-bar.component.html